import { render, staticRenderFns } from "./brand-banner.vue?vue&type=template&id=5cace320&scoped=true&"
import script from "./brand-banner.vue?vue&type=script&lang=js&"
export * from "./brand-banner.vue?vue&type=script&lang=js&"
import style0 from "./brand-banner.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-banner.vue?vue&type=style&index=1&id=5cace320&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cace320",
  null
  
)

export default component.exports